// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3Pcik","colCheckbox":"styles_colCheckbox__3hlWd"};